<div class="progress-bar" [ngStyle]="{'width':pourcent + '%'}"></div>
@for (step of steps; track step) {
  <div class="circle" [ngStyle]="{'left':step + '%'}"></div>
}
